import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { Release, AppMode } from "@/CodegenTypes";
import { useTranslation } from "@/store/translation";
import { useQuery } from "@vue/apollo-composable";
import { first } from "lodash";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'TtResults',
  setup(__props) {

const route = useRoute()
const { $t } = useTranslation();


const { result, loading } = useQuery<{ releases: Release[] }>(queries.releasesWithResults, {
  appMode: AppMode.Tt,
  weeksBackCount: 1,
}, {
  fetchPolicy: "cache-and-network",
})

const selectedResults = computed(() => {

  const results = selectedRelease.value?.ttResults;

  if (results) {
    return results;
  } else {
    return {
      additionalNumber: '-',
      winningNumber1: '-',
      winningNumber2: '-',
      winningNumber3: '-',
      winningNumber4: '-',
      winningNumber5: '-',
      winningNumber6: '-',
    }
  }
})


const selectedRelease = computed(() => {

  const release = result.value?.releases.find(
    (r) => r.releaseDate === selectedStartReleaseDate.value
  );

  // hide if not reports generated
  if (!release?.reportsGenerated) {
    return null;
  }

  return release;
})



const selectedStartReleaseDate = computed(() => {

  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


return { __sfc: true,route, $t, result, loading, selectedResults, selectedRelease, selectedStartReleaseDate }
}

})